import { Pipe, PipeTransform, Input } from "@angular/core";
import * as moment from "moment";

@Pipe({ name: "countDown" })
export class CountDownPipe implements PipeTransform {
  transform(value: any, isStarted, isFinished, statuses): any {
    if (
      statuses &&
      (statuses.key === "active" || statuses.key === "not_started")
    ) {
      if (isStarted) {
        if (isFinished) {
          return "აუქციონი დასრულებულია";
        } else {
          const days = Math.floor(value / (60 * 60 * 24));
          const hours = Math.floor((value % (60 * 60 * 24)) / (60 * 60));
          const minutes = Math.floor((value % (60 * 60)) / 60);
          const seconds = Math.floor(value % 60);

          return (
            (days != 0 ? days + " დღე " : "") +
            (hours != 0 ? this.pad(hours) + ":" : "00:") +
            (minutes != 0 ? this.pad(minutes) + ":" : "00:") +
            this.pad(seconds)
          );
        }
      } else {
        return moment(value * 1000).format("DD.MM.Y | HH:mm:ss");
      }
    } else {
      return statuses ? statuses.name : "";
    }
  }

  pad(n) {
    return n > 9 ? n : "0" + n;
  }
}
